<dx-pie-chart [dataSource]="chartData"
              [animation]="false"
              type="doughnut"
              centerTemplate="centerTemplate"
              [customizePoint]="customiseChartPoint"
              [startAngle]="90"
              [innerRadius]="0.65">
    <dxi-pie-chart-series argumentField="category"
                          valueField="percentage">
        <dxo-pie-chart-label [visible]="false"></dxo-pie-chart-label>
    </dxi-pie-chart-series>
    <dxo-pie-chart-size [height]="140"
                        [width]="140"></dxo-pie-chart-size>
    <dxo-pie-chart-legend [visible]="false"></dxo-pie-chart-legend>
    <svg *dxTemplate="let pieChart of 'centerTemplate'">
        <circle cx="50"
                cy="50"
                [attr.r]="pieChart.getInnerRadius() - 4"
                fill="#eee"></circle>
        <text text-anchor="middle"
              x="50"
              y="50"
              fill="#494949">
            <tspan x="50"
                   style="font-size: 28px">{{ percentage.toFixed(0) }}%</tspan>
            <tspan x="50"
                   dy="20px"
                   style="font-size: 14px">{{ text }}</tspan>
        </text>
    </svg>
</dx-pie-chart>
